import { render } from "./LeftDrawer.vue?vue&type=template&id=473b6c0e&scoped=true"
import script from "./LeftDrawer.vue?vue&type=script&lang=js"
export * from "./LeftDrawer.vue?vue&type=script&lang=js"

import "./LeftDrawer.vue?vue&type=style&index=0&id=473b6c0e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-473b6c0e"]])

export default __exports__